// extracted by mini-css-extract-plugin
export default {"wrapper":"eltkeG1y8KNVrFlwFJkz","large":"oi2uEcxZav5eT0I8IGBa","full":"VC53NykEsVT9OfJ3Vw0j","scene":"go7Vq7o_pxFD1k7nCYX9"};